// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Button} from '../lib/button';
import {Button as Button_shared} from '../../../shared/ui/button';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {toolip_img_url} from '../ui/toolip_img_url';
import Woops_oculus from '../../../oculus/pub/img/woops_oculus.svg';
import Woops_browserai from '../../../browserai/pub/img/woops.svg';

import styles from './woops_payment.module.less';

export const Woops_payment_hola2023 = ({on_close}: {on_close: ()=>void})=>{
    const {theme, theme_name} = useContext(Settings_context);
    return <div className={cn(styles.root_hola2023, styles.woops,
      theme_name=='toolip' && styles.no_gap,
      theme_name=='toolip' && styles.with_logo)}>
      {theme_name=='toolip' && <img alt="logo_dark"
        src={toolip_img_url('toolip/logo_black.svg')}
        width={62} className={cn(styles.m32, styles.left_align)}/>}
      {theme_name=='toolip' ?
      <img src={toolip_img_url('woops.png')} width={120} alt="woops"
        className={cn(styles.m32, 'lazyload')}/> :
      <img src="/cms/wp-content/uploads/2023/09/image_free.png"
        alt="image_free" className="lazyload"/>}
      <p className={cn(theme.p2, theme.bold, styles.title)}>
        Woops! Looks like there was an error to process your payment.
      </p>
      <p className={cn(theme.p3)}>
        Don't worry, you were NOT charged!
        Please verify your details and try again.
      </p>
      <Button on_click={on_close} caption="Thanks, got it" round={false}
        color="white"/>
      <p className={cn(theme.p3, styles.help)}>
        Need Help? Go to <a href="/support">Support</a>
      </p>
    </div>;
};

export const Woops_payment = ({on_close}: {on_close: ()=>void})=>{
    return <div className={styles.root}>
      <img src={'/cms/wp-content/uploads/2023/05/woops.png'}
        className={cn(styles.img, 'lazyload')} width={148} height={120}
        alt="woops"/>
      <h3>Woops!</h3>
      <p><b>Looks like there was an error to process your payment.</b></p>
      <p>Don't worry, you were <b>NOT</b> charged! Please verify your
        details and try again.</p>
      <Button on_click={on_close} caption={'OK'} size={'sm'}
        color={'white'}/>
    </div>;
};

export const Woops_payment_oculus = ({on_close}: {on_close: ()=>void})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.thank_you}>
      <Woops_oculus/>
      <p className={cn(theme.p20, theme.bold, theme.color_n700, styles.title)}>
        Woops! Looks like there was an error to process your payment.</p>
      <p className={cn(theme.p16, theme.med, theme.color_n600)}>
        Don't worry, you were NOT charged! Please verify your details and try
        again.</p>
      <Button caption={'Got it'} no_jump size={'md'} round={false} fit
        cls={styles.thank_you_btn} on_click={on_close} width={120}/>
      <p className={theme.p14}>
        Need our help with anything?{' '}
        <a className={styles.link} href={'mailto:support@oculusproxies.com'}>
          Contact support</a>
      </p>
    </div>;
};

export const Woops_payment_browserai = ({on_close}: {on_close: ()=>void})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.thank_you}>
      <Woops_browserai/>
      <p className={cn(theme.p18, theme.bold, theme.color_n1100,
        styles.title)}>
        Woops! Looks like there was an error to process your payment.</p>
      <p className={cn(theme.p14, theme.color_n800)}>
        Don't worry, you were NOT charged!
        <br/>Please verify your details and try again</p>
      <Button_shared caption={'Thanks, got it'} size={'md'} fit
        cls={styles.thank_you_btn_extra} color="secondary"
        on_click={on_close} />
      <p className={cn(theme.p14, theme.color_n800)}>
        Need our help?{' '}
        <a className={styles.link_no_underline}
          href={'mailto:support@browser.ai'}>Go to support</a>
      </p>
    </div>;
};
